import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable } from 'rxjs';
import { AppAuthGuard } from './app.authguard';
import { SharedService } from '@core/services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivatePR  {
    private keycloakAngular = inject(KeycloakService);
    private router = inject(Router);
    private authguard = inject(AppAuthGuard);
    private sharedService = inject(SharedService);

    isLogedin:boolean=false
    isCustom:boolean=false
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


  return this.authguard.canActivate(next, state).then((auth: boolean) => {
    this.isCustom = this.sharedService.checkRoute();
    if (!auth || this.isCustom) {
      if (this.isCustom) {
        this.router.navigate(['/home']);
      }
      return false;
    }
    const data = this.keycloakAngular.getUserRoles(); 

    let adminFound = false;
    let prFound = false; 
    
    for (const [key, value] of Object.entries(data)) {
        if (value === 'ROLE_PR_ADMIN' && !adminFound) {
            adminFound = true;
        } else if (value === 'ROLE_PR') {
            prFound = true;
        }
    }

    if (adminFound || prFound) {
        return true;
    } else {
        this.router.navigate(['/home']);
        return false;
    }
  });
}
}